/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 *
 * ----------------------------------------------------------------------
 *
 * Copied from the DH Garage UI and then tweaked
 */
import { LogLevel } from '@azure/msal-browser';
import { getAppConfig, getB2BPolicyInfo } from '../..';
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export function getB2BConfig() {
    const configuration = getAppConfig();
    const aADPolicies = getB2BPolicyInfo();
    return {
        auth: {
            clientId: configuration.REACT_APP_MSAL_CLIENT_ID,
            authority: aADPolicies.authority,
            redirectUri: configuration.REACT_APP_BASEURL,
            postLogoutRedirectUri: configuration.REACT_APP_BASEURL,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
        system: {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Info:
                            // for debugging only - too chatty otherwise
                            //  console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                        case LogLevel.Error:
                        default:
                            console.error(message);
                            return;
                    }
                },
            },
        },
    };
}
